/**
 * 救援目标 / 轨迹拉取（从 Dashboard 拆出）
 */

import { isRescueTargetExpired } from '../rescuePush/constants';

export function filterActiveRescueItems(items = []) {
  const now = Date.now();
  return (items || []).filter((item) => {
    if (item.status === '已完结') return false;
    if (isRescueTargetExpired(item, now)) return false;
    return true;
  });
}

/**
 * @param {(url: string, options?: object) => Promise<Response>} fetchFn
 * @returns {Promise<{ targets: Array, tracks: Array }>}
 */
export async function fetchActiveRescueData(fetchFn) {
  const [targetResponse, trackResponse] = await Promise.all([
    fetchFn('/api/rescue/target'),
    fetchFn('/api/rescue/track')
  ]);

  const targetData = await targetResponse.json();
  const trackData = await trackResponse.json();

  const targets = targetData.success && targetData.targets
    ? filterActiveRescueItems(targetData.targets)
    : [];
  const tracks = trackData.success && trackData.tracks
    ? filterActiveRescueItems(trackData.tracks)
    : [];

  return { targets, tracks };
}
